import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Row } from 'react-bootstrap';

const Globals = require('../../../../app/globals');
import DateString from '../common/DateString';
import ExpansionButton from '../common/ExpansionButton';
import AccessibleIcon from '../common/AccessibleIcon';

const propTypes = {
    className: PropTypes.string,
    project: PropTypes.object.isRequired,
    onToggleExpansion: PropTypes.func.isRequired,
    expanded: PropTypes.bool,
    depth: PropTypes.number,
    contentType: PropTypes.oneOf([Globals.content_type.ACTIVITY, Globals.content_type.COURSE]).isRequired,
};

const defaultProps = {
    className: '',
    expanded: false,
    depth: 0,
};

function ProjectListItem(props) {
    if (!props.project) {
        return null;
    }

    const projectHref = `/project/${props.project.channelId}/${props.project.id}`;

    return (
        <li className={`${props.className} listing--noBg projectListing`}>
            <Row className="projectListing__wrapper">
                <div className={`col-3 col-sm-2 col-md-1 projectListing__col--control projectListing__col--depth-${props.depth} nowrap`}>
                    <div className="listDepthWrapper">
                        <ExpansionButton
                            className="width-100p height-100p text-left padding-l-sm"
                            expanded={props.expanded}
                            onClick={props.onToggleExpansion}
                            expandedIcon="fa-caret-down"
                            collapsedIcon="fa-caret-right"
                        >
                            <AccessibleIcon className="fa fa-lightbulb-o fa-lg fa-fw" label="Folder" />
                        </ExpansionButton>
                    </div>
                </div>
                <Link
                    to={projectHref}
                    className="col-7 col-sm-7 col-md-5 col-lg-3 projectListing__col--clipText link-plain link-body-color"
                >
                    <div title={props.project.name}>{props.project.name}</div>
                </Link>
                <Link
                    to={projectHref}
                    className="d-none d-sm-none d-md-flex col-md-2 col-lg-2 projectListing__col link-plain link-body-color nowrap text-md"
                >
                    <DateString shortMonth date={props.project.created_at} />
                </Link>
                <Link
                    to={projectHref}
                    className="d-none d-sm-none d-md-flex col-md-2 col-lg-2 projectListing__col link-plain link-body-color nowrap text-md"
                >
                    {(props.project.modified) ?
                        <DateString shortMonth date={props.project.modified} />
                        :
                        'Never'
                    }
                </Link>
                <Link
                    to={projectHref}
                    className="col-2 col-sm-2 col-md-1 col-lg-1 projectListing__col--text-right link-plain link-body-color text-md"
                >
                    {(props.contentType === Globals.content_type.ACTIVITY) ?
                        props.project.activity_count
                        :
                        null
                    }
                    {(props.contentType === Globals.content_type.COURSE) ?
                        props.project.short_course_count
                        :
                        null
                    }
                </Link>
                <Link
                    to={projectHref}
                    className="d-none d-sm-none d-md-none d-lg-flex col-lg-1 projectListing__col--text-right link-plain link-body-color text-md"
                >
                    {(props.contentType === Globals.content_type.ACTIVITY) ?
                        props.project.published_activity_count
                        :
                        null
                    }
                    {(props.contentType === Globals.content_type.COURSE) ?
                        props.project.published_short_course_count
                        :
                        null
                    }
                </Link>
            </Row>
        </li>
    );
}

ProjectListItem.propTypes = propTypes;
ProjectListItem.defaultProps = defaultProps;

export default ProjectListItem;
